import { ref } from "vue";
import { Incident } from "../types/Incidents";
import { ExemptionsType } from "../views/Common/_shared/Exemptions/exemptions.types";

export const FETCHING = "FETCHING";
export const READY = "READY";
export const UPDATING = "UPDATING";
export const ERROR = "ERROR";
export const EXEMPT = "EXEMPT";
export const SLIDE_OUT = "SLIDE_OUT";

type FetchingState = { type: typeof FETCHING };
type ReadyState = { type: typeof READY };
type UpdatingState = { type: typeof UPDATING };
type ErrorState = { type: typeof ERROR };
type ExemptState = {
  type: typeof EXEMPT;
  senderValue: string;
  senderType: ExemptionsType;
};
type SlideOutState = {
  type: typeof SLIDE_OUT;
  incident: Incident;
};

type State =
  | FetchingState
  | ReadyState
  | UpdatingState
  | ErrorState
  | ExemptState
  | SlideOutState;

export const useIncidentsState = () => {
  const state = ref<State>({ type: FETCHING });
  const isFetchingState = (state: State): state is FetchingState =>
    state.type === FETCHING;
  const isReadyState = (state: State): state is ReadyState =>
    state.type === READY;
  const isUpdatingState = (state: State): state is UpdatingState =>
    state.type === UPDATING;
  const isErrorState = (state: State): state is ErrorState =>
    state.type === ERROR;
  const isExemptState = (state: State): state is ExemptState =>
    state.type === EXEMPT;
  const isSlideOutState = (state: State): state is SlideOutState =>
    state.type === SLIDE_OUT;

  const setState = (newState: State) => (state.value = newState);

  return {
    state,
    isFetchingState,
    isReadyState,
    isUpdatingState,
    isErrorState,
    isExemptState,
    isSlideOutState,
    setState,
  };
};

export default {};
